import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import MissionName from './header/MissionName';
import useAgent from '../../../common/hooks/useAgent';
import patrolAgent from '../../agents/patrolAgent';
import HeaderActions from './header/HeaderActions';
import useStyles from './PatrolSummary.styles';
import PatrolBody from './body/PatrolBody';
import { Container } from '../../../common/components/layout';
import { ContainerLoader } from '../../../common/components/loaders';

const defaultFilters = {
  hideRegularPassengerVehicles: true,
  hideAutomaticallyNotedThreats: true,
};

const PatrolSummary = ({ onBackClick }) => {
  const classes = useStyles();

  const { id } = useParams();
  const [fetchPatrol, patrol, isFetchingPatrol] = useAgent(patrolAgent.fetchPatrol);
  const [fetchFindings, findingsData, isFetchingFinding] = useAgent(patrolAgent.fetchFindings);
  const [localFindings, setLocalFindings] = useState([]);
  const [filters, setFilters] = useState(defaultFilters);

  const handleFindingsUpdate = useCallback((updatedFinding) => {
    setLocalFindings((oldFindings) => {
      const index = oldFindings.findIndex((f) => f.id === updatedFinding.id);
      const newFindings = [...oldFindings];
      newFindings[index] = { ...oldFindings[index], ...updatedFinding };
      return newFindings;
    });
  }, []);

  useEffect(() => {
    fetchFindings(id, defaultFilters);
    fetchPatrol(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch functions aren't memoised
  }, [id]);

  useEffect(() => {
    if (findingsData && findingsData.findings) setLocalFindings(findingsData.findings);
  }, [findingsData]);

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    fetchFindings(id, newFilters);
  };

  if (!patrol || isFetchingPatrol) return <ContainerLoader />;

  return (
    <Container>
      <div className={classes.header}>
        <MissionName patrol={patrol} />
        <HeaderActions patrol={patrol} findings={localFindings} onBackClick={onBackClick} filters={filters} />
      </div>
      <PatrolBody
        patrol={patrol}
        isFetchingFindings={isFetchingFinding}
        findings={localFindings}
        onFiltersChange={handleFiltersChange}
        onFindingUpdate={handleFindingsUpdate}
      />
    </Container>
  );
};

PatrolSummary.propTypes = {
  onBackClick: PropTypes.func,
};

PatrolSummary.defaultProps = {
  onBackClick: undefined,
};

export default PatrolSummary;
